import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import styles from './styles'
import './styles.css'
import { withStyles } from '@material-ui/core'
import HorizontalPinLogo from '../../assets/images/horizontal_pin_logo.png'
import VerticalPinLogo from '../../assets/images/vertical_pin_logo.png'
import SafeLogo from '../../assets/images/Safe_Logo.png'

class Loading extends React.Component {
  state = {
    logoclasses: false,
    logoclasses2: false,
    showPin: false
  }

  componentDidMount() {
    this.timer = setTimeout(() => {
      this.setState({ showPin: true })
    }, 2750)
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  render() {
    return (
      <div className="wrapper">
        <div className="inner">
          <div className="pin-wrapper">
            <img src={VerticalPinLogo} alt="pin" />
          </div>
          {this.state.showPin ? (
            <div className="pin2-wrapper">
              <img src={HorizontalPinLogo} alt="pin" />
            </div>
          ) : (
            ''
          )}
          <div className="logo-wrapper">
            <img src={SafeLogo} alt="safe" className="" />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = () => {
  return {}
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true })
)(Loading)
